import { initializePlatformStorage, sessionStore } from '../platform/storage';

const accessKey = 'pulsora_access_token';
const refreshKey = 'pulsora_refresh_token';
const centerKey = 'pulsora_center_id';
const roleKey = 'pulsora_active_role';

export const SESSION_STORAGE_KEYS = { accessKey, refreshKey, centerKey, roleKey };

const safeLocal = () => {
  try { return window.localStorage; } catch (_) { return null; }
};

export const initializeSessionStorage = () => initializePlatformStorage();

/**
 * Web: cada pestaña conserva sus credenciales en sessionStorage.
 * Native: los mismos valores viven en Keychain (iOS) / Android Keystore
 * mediante el adapter seguro de Capacitor y se exponen desde una cache en
 * memoria para mantener compatible el resto del frontend.
 */
export const migrateLegacySession = () => {
  if (sessionStore.isNative) return;
  const local = safeLocal();

  const legacyAccess = local?.getItem(accessKey) || local?.getItem('sowabox_access_token');
  const legacyRefresh = local?.getItem(refreshKey);
  const legacyCenter = local?.getItem(centerKey);

  if (!sessionStore.getItem(accessKey) && legacyAccess) sessionStore.setItem(accessKey, legacyAccess);
  if (!sessionStore.getItem(refreshKey) && legacyRefresh) sessionStore.setItem(refreshKey, legacyRefresh);
  if (!sessionStore.getItem(centerKey) && legacyCenter) sessionStore.setItem(centerKey, legacyCenter);

  local?.removeItem(accessKey);
  local?.removeItem(refreshKey);
  local?.removeItem(centerKey);
  local?.removeItem('sowabox_access_token');
};

export const getAccessToken = () => sessionStore.getItem(accessKey);
export const getRefreshToken = () => sessionStore.getItem(refreshKey);
export const getCenterId = () => sessionStore.getItem(centerKey);
export const getRoleName = () => sessionStore.getItem(roleKey);

export const setSessionTokens = ({ access, refresh }) => {
  if (access) sessionStore.setItem(accessKey, access);
  if (refresh) sessionStore.setItem(refreshKey, refresh);
};

export const clearSessionTokens = () => {
  sessionStore.removeItem(accessKey);
  sessionStore.removeItem(refreshKey);
  sessionStore.removeItem(centerKey);
  sessionStore.removeItem(roleKey);
};

export const setCenterId = value => {
  if (value === null || value === undefined || value === '') sessionStore.removeItem(centerKey);
  else sessionStore.setItem(centerKey, String(value));
};

export const setRoleName = value => {
  if (!value) sessionStore.removeItem(roleKey);
  else sessionStore.setItem(roleKey, String(value));
};
